import Swiper, {
  Autoplay,
  Navigation,
  Pagination,
  EffectFade,
  Scrollbar,
  FreeMode,
  Mousewheel,
} from "swiper";

// Wait for DOM to be ready
document.addEventListener("DOMContentLoaded", function () {
  Swiper.use([
    Autoplay,
    Navigation,
    Pagination,
    EffectFade,
    Scrollbar,
    FreeMode,
    Mousewheel,
  ]);

  let sliderCaseStudies = null;
  const caseStudiesSelector = ".slider__case-studies";

  function handleCaseStudiesSlider() {
    const el = document.querySelector(caseStudiesSelector);
    if (!el) return;

    if (window.innerWidth < 1024) {
      if (!sliderCaseStudies) {
        sliderCaseStudies = new Swiper(caseStudiesSelector, {
          loop: true,
          spaceBetween: 24,
          slidesPerView: 1,
          autoHeight: true,
          pagination: {
            el: caseStudiesSelector + " .slider-pagination",
            bulletClass: "pagination-bullet",
            bulletActiveClass: "active",
            bulletElement: "button",
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
          },
        });
      }
    } else {
      if (sliderCaseStudies) {
        sliderCaseStudies.destroy(true, true);
        sliderCaseStudies = null;
      }
    }
  }

  if (document.querySelector(caseStudiesSelector)) {
    handleCaseStudiesSlider();
    window.addEventListener("resize", handleCaseStudiesSlider);
  }

  let sliderServices = null;
  const servicesSelector = ".slider__services";

  function handleServicesSlider() {
    const el = document.querySelector(servicesSelector);
    if (!el) return;

    if (!sliderServices) {
      sliderServices = new Swiper(servicesSelector, {
        freeMode: true,
        mousewheel: true,
        spaceBetween: 24,
        slidesPerView: 1,
        scrollbar: {
          el: servicesSelector + " .slider-scrollbar",
          hide: false,
          dragClass: "slider-scrollbar-drag",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 80,
          },
        },
      });
    }
  }

  if (document.querySelector(servicesSelector)) {
    handleServicesSlider();
  }

  let sliderTestimonials = null;
  const testimonialsSelector = ".slider__testimonials";

  if (document.querySelector(testimonialsSelector)) {
    handleTestimonialsSlider();
  }

  function handleTestimonialsSlider() {
    const el = document.querySelector(testimonialsSelector);
    if (!el) return;

    if (!sliderTestimonials) {
      sliderTestimonials = new Swiper(testimonialsSelector, {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        spaceBetween: 80,
        slidesPerView: 1,
        pagination: {
          el: testimonialsSelector + " .slider-pagination",
          bulletClass: "pagination-bullet",
          bulletActiveClass: "active",
          bulletElement: "button",
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<button type="button" class="' +
              className +
              '" aria-label="Go to testimonial ' +
              (index + 1) +
              '"></button>'
            );
          },
        },
      });
    }
  }

  let sliderTeam = null;
  const teamSelector = ".slider__team";
  const teamNavigation = ".slider-navigation";

  if (document.querySelector(teamSelector)) {
    handleTeamSlider();
  }

  function handleTeamSlider() {
    const el = document.querySelector(teamSelector);
    if (!el) return;

    const slides = document.querySelectorAll(teamSelector + " .swiper-slide");

    sliderTeam = new Swiper(teamSelector, {
      spaceBetween: 80,
      slidesPerView: 1,
      navigation: {
        nextEl: ".btn-next",
        prevEl: ".btn-prev",
        disabledClass: "opacity-10",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });

    if (slides.length <= 3) {
      document.querySelector(teamNavigation).remove();
    }
  }

  let sliderAccreditations = null;
  const accreditationsSelector = ".slider__accreditations";

  if (document.querySelector(accreditationsSelector)) {
    handleAccreditationsSlider();
  }

  function handleAccreditationsSlider() {
    const el = document.querySelector(accreditationsSelector);
    if (!el) return;

    if (!sliderAccreditations) {
      sliderAccreditations = new Swiper(accreditationsSelector, {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        spaceBetween: 48,
        slidesPerView: 2,
        slidesPerGroup: 2,
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1024: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
        },
        pagination: {
          el: accreditationsSelector + " .slider-pagination",
          bulletClass: "pagination-bullet",
          bulletActiveClass: "active",
          bulletElement: "button",
          clickable: true,
        },
      });
    }
  }

  let sliderFeatures = null;
  const featuresSelector = ".slider__features";

  if (document.querySelector(featuresSelector)) {
    handleFeaturesSlider();
  }

  function handleFeaturesSlider() {
    const el = document.querySelector(featuresSelector);
    if (!el) return;

    if (!sliderFeatures) {
      sliderFeatures = new Swiper(featuresSelector, {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        spaceBetween: 48,
        slidesPerView: 1,
        pagination: {
          el: featuresSelector + " .slider-pagination",
          bulletClass: "pagination-bullet",
          bulletActiveClass: "active",
          bulletElement: "button",
          clickable: true,
        },
        navigation: {
          nextEl: featuresSelector + " .btn-next",
          prevEl: featuresSelector + " .btn-prev",
          disabledClass: "opacity-50",
        },
      });
    }
  }
});
